export const GetHousingSelector = ({ housing: { GetHousing } }) => GetHousing;
export const HousingSelector = ({ housing: { Housing } }) => Housing;
